import { useState, type FormEvent } from 'react';
import { adminApi } from '@/lib/adminApi';

interface Props {
  onSuccess: (token: string) => void;
}

export const AdminLoginPage = ({ onSuccess }: Props) => {
  const [password, setPassword] = useState('');
  const [totp, setTotp] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { token } = await adminApi.login(password, totp);
      onSuccess(token);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-shell">
      <div className="admin-login">
        <div className="admin-login__header">
          <span className="admin-login__eyebrow">PublishWeaver</span>
          <h1 className="admin-login__title">Studio</h1>
        </div>

        <form className="admin-form" onSubmit={handleSubmit}>
          <div className="admin-field">
            <label htmlFor="pw" className="admin-label">Password</label>
            <input
              id="pw"
              type="password"
              className="admin-input"
              value={password}
              onChange={(e) => { setPassword(e.target.value); }}
              autoComplete="current-password"
              required
            />
          </div>

          <div className="admin-field">
            <label htmlFor="totp" className="admin-label">Authenticator code</label>
            <input
              id="totp"
              type="text"
              className="admin-input admin-input--code"
              value={totp}
              onChange={(e) => { setTotp(e.target.value.replace(/\D/g, '').slice(0, 6)); }}
              inputMode="numeric"
              autoComplete="one-time-code"
              placeholder="000000"
              maxLength={6}
              required
            />
          </div>

          {error && <p className="admin-error">{error}</p>}

          <button type="submit" className="admin-btn" disabled={loading}>
            {loading ? 'Verifying…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
};
